import React, { useEffect, useMemo } from 'react'

import SendModal from '@/components/Modals/Wallet/SendModal'
import { useBalancesContext } from '@/contexts/BalancesContext'
import { useGovernanceContext } from '@/contexts/GovernanceContext'
import { useModalContext } from '@/contexts/ModalContext'
import { useAuth } from '@/plugins/auth'
import { emptyBalance } from '@/utils/utils'

import ViewApplicationModal from './Governance/ViewApplicationModal'
import ManageTokensModal from './Wallet/ManageTokensModal'
import ReceiveModal from './Wallet/ReceiveModal'
import SignatureModal from './Wallet/SignatureModal'
import UnwrapModal from './Wallet/UnwrapModal'

const ModalWrapper: React.FC = () => {
  const { modalType, modalProps, closeModal } = useModalContext()
  const { electionData } = useGovernanceContext()
  const { status } = useAuth()
  const {
    ll1: { withdrawable: ll1Withdrawable },
    rl1: { withdrawableOld: rl1WithdrawableOld, withdrawableNew: rl1WithdrawableNew },
  } = useBalancesContext()

  useEffect(() => {
    if (status !== 'connected') {
      closeModal()
    }
  }, [status, closeModal])

  // Voting period started, so users cannot fill applications anymore or edit
  const fillApplicationPeriodEnded = useMemo(() => {
    const now = new Date().getTime() / 1000
    return electionData.campaignTime < now
  }, [electionData])

  if (!modalType) {
    return null
  }

  switch (modalType) {
    case 'send':
      return <SendModal close={closeModal} />
    case 'receive':
      return <ReceiveModal close={closeModal} />
    case 'watchTokens':
      return <ManageTokensModal network="Lamina1" close={closeModal} />
    case 'watchTokensAvax':
      return <ManageTokensModal network="Avalanche" close={closeModal} />
    case 'signature':
      return <SignatureModal close={closeModal} />
    case 'unwrapRL1':
      return (
        <UnwrapModal
          unwrap="RL1"
          amount={rl1WithdrawableNew}
          oldAmount={rl1WithdrawableOld}
          close={closeModal}
        />
      )
    case 'unwrapLL1':
      return (
        <UnwrapModal
          unwrap="LL1"
          amount={ll1Withdrawable}
          oldAmount={emptyBalance}
          close={closeModal}
        />
      )
    case 'viewApplication':
      return (
        <ViewApplicationModal
          nominee={modalProps?.nominee}
          close={closeModal}
          fillApplicationPeriodEnded={fillApplicationPeriodEnded}
        />
      )
    default:
      return null
  }
}

export default ModalWrapper
